export const getActivityRenderedContent = (
  renderedContent: Record<string, { title: string; main?: string; expanded?: string }>,
  currentLanguage: 'en' | 'de' | (string & {})
) => {
  let renderLanguage: 'en' | 'de' = 'en'
  if (currentLanguage in renderedContent) {
    renderLanguage = currentLanguage as 'de'
  }
  const { title, main, expanded } = renderedContent[renderLanguage] || renderedContent['en']
  return { title, main, expanded }
}
